import Model from '../model.js';

export default class Setting extends Model
{
    constructor(id, category, key, valueType, value, updatedAt, createdAt){ 
        super()
        this.id                 = id ?? 0;
        this.category           = category;
        this.key                = key;
        this.valueType          = valueType;
        this.value              = value;
        this.updatedAt          = updatedAt;
        this.createdAt          = createdAt;

        this.init()
    }

    update(data){
        Object.assign(this, data)
    }
}

